import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';

class Signin extends Component {

  componentDidMount() {
    // Change style of the wrapper so we can put a background image on
    document.getElementById("wrapper").class = "img-cover";
    document.getElementById("wrapper").style = "background-image: url(assets/img/photos-1/1.jpg); background-repeat: no-repeat; background-size: cover";
  }

  componentWillUnmount() {
    document.getElementById("wrapper").class = "wrapper";
    document.getElementById("wrapper").style = '';
  }

  handleFormSubmit({email, password}) {
    // Grab the subdomain to send with login credentials to the API
    let subdomain = window.location.host.split('.')[0];

    // Log user in (also send redirect and subdomain)
    this.props.signinUser({ email, password }, () => this.props.history.push('/pos/openorders'), subdomain);
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return (
        <div className="alert alert-danger">
          <strong>Error: </strong> {this.props.errorMessage}
        </div>
      );
    }
  }

  render() {
    const { handleSubmit } = this.props;

    var style = {
      width: '50%',
      textAlign: 'center',
      marginLeft: 0,
    }

    return (
      <div className="container-fluid">
        <div className="sign-form">
          <div className="row">
            <div className="col-md-4 offset-md-4 px-3">
              <div className="box b-a-0 mb-0">
                <div className="p-2 text-xs-center">
                  <h5>DineOS Dashboard</h5>
                </div>
                <form className="form-material mb-1" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                  <fieldset className="form-group">
                    <Field name="email" component="input" type="text" className="form-control" placeholder="Email" />
                  </fieldset>
                  <fieldset className="form-group">
                    <Field name="password" component="input" type="password" className="form-control" placeholder="Password" />
                  </fieldset>
                  {this.renderAlert()}
                  <div className="px-2 form-group mb-0 pt-1">
                    <button action="submit" className="btn btn-rounded btn-secondary btn-block text-uppercase">Sign In</button>
                  </div>

                </form>
                <div className="p-2 text-xs-center text-muted">
                  Don't have an account? <a className="text-black" href="#signup">Sign Up</a>
                  <br />
                  <a className="text-black" href="/forgotpassword">Forgot Password?</a>
                </div>

                <br />
                <ul className="nav nav-pills nav-fill nav-pills-color">
                  <li className="nav-item" style={style}>
                    <a className="nav-link active nav-pills-dash" href="#dash">Dashboard</a>
                  </li>
                  <li className="nav-item" style={style}>
                    <a className="nav-link nav-pills-pos" href="/signinpos">Point of Sale</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const signinForm = reduxForm({
  form: 'signin'
})(Signin);

function mapStateToProps(state) {
  return { errorMessage: state.auth.error };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(signinForm);



// WEBPACK FOOTER //
// ./src/containers/auth/signin.js